import {ACTION_CATEGORY, ANALYTICS_MODULE} from 'analytics/AnalyticsTypes';

export const MODBIO_ANALYTICS_ACTIONS = {
  OPENED_MOD_PATTERN_MODAL: {
    module: ANALYTICS_MODULE.MODBIO,
    action: 'opened_mod_pattern_modal',
    actionCategory: ACTION_CATEGORY.READ,
  },
  REACHED_MOD_PATTERN_APPLY_PANE: {
    module: ANALYTICS_MODULE.MODBIO,
    action: 'reached_mod_pattern_apply_pane',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_FIND_AND_REPLACE_MODAL: {
    module: ANALYTICS_MODULE.MODBIO,
    action: 'opened_find_and_replace_modal',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_ATTACHMENT_MODAL_FOR_COMPLEX_POLYMER_EDIT: {
    module: ANALYTICS_MODULE.MODBIO,
    action: 'opened_attachment_modal_for_complex_polymer_edit',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_CONFIGURE_ATTACHMENTS_FOR_COMPLEX_POLYMER_CREATE: {
    module: ANALYTICS_MODULE.MODBIO,
    action: 'opened_configure_attachments_for_complex_polymer_create',
    actionCategory: ACTION_CATEGORY.READ,
  },
  TOGGLED_ATTACHMENT_STYLE_IN_ATTACHMENT_MODAL: {
    module: ANALYTICS_MODULE.MODBIO,
    action: 'toggled_attachment_style_in_attachment_modal',
    actionCategory: ACTION_CATEGORY.READ,
  },
  ADDED_ATTACHMENT_IN_ATTACHMENT_MODAL: {
    module: ANALYTICS_MODULE.MODBIO,
    action: 'added_attachment_in_attachment_modal',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
};
